import React, { useState, useEffect } from 'react'
import { Spin, Button, message } from 'antd'
import './index.less'
import moment from 'moment'
import { getParmUrl } from '../../public/utils'
import { fetchBatchDeliveryExcel } from './service'

const WithPrintNew = (props) => {
  const [sping, setSping] = useState(false)
  const [data, setData] = useState({})

  useEffect(() => {
    setSping(true)
    getPrint()
  }, [])

  const getPrint = async () => {
    try {
      const res = await fetchBatchDeliveryExcel({
        delivery_code_list: [getParmUrl('DeliveryCode')],
      })
      if (String(res.data.code) === '0' && res.data.data) {
        setSping(false)
        // 接口返回数组，单条打印取第一条
        const list = Array.isArray(res.data.data) ? res.data.data : [res.data.data]
        setData(list[0] || {})
      } else {
        message.error(res.data.message || '获取打印数据失败')
      }
    } catch (err) {
      console.log(err)
    }
  }

  const print = () => {
    window.document.body.innerHTML = window.document.getElementsByClassName('printBody')[0].innerHTML
    window.print()
    window.location.reload()
  }

  const goback = () => {
    props.history.push('/main/deliverGoodsNew/deliverList')
  }

  const renderText = (text) => text || text === 0 ? text : '-'

  return (
    <div className="returnList">
      <Spin spinning={sping}>
        <div className="search" style={{ width: '90%', marginLeft: '5%' }}>
          <div className="printBody">
            <h1 style={{ fontSize: '28px', fontWeight: 'bold', textAlign: 'center' }}>{data.title || ''}</h1>
            <p style={{ borderTop: '1px solid #e5e5e5', padding: '10px 5px', margin: 0 }}>
              <span style={{ display: 'inline-block', width: '35%' }}>收货单位：{data.recevier || '-'}</span>
              <span>发货日期：{data.delivery_date ? moment(data.delivery_date).format('YYYY-MM-DD') : '-'}</span>
            </p>
            <p style={{ borderTop: '1px solid #e5e5e5', padding: '10px 5px', margin: 0 }}>
              <span style={{ display: 'inline-block', width: '35%' }}>收货地址：{data.address || '-'}</span>
              <span>收货联系人：{data.recevieruser || '-'}</span>
            </p>
            <p style={{ borderTop: '1px solid #e5e5e5', padding: '10px 5px', margin: 0 }}>
              <span style={{ display: 'inline-block', width: '35%' }}>客户订单号：{data.cg_num || '-'}</span>
              <span>联系电话：{data.linktel || '-'}</span>
            </p>
            <table style={{ width: '100%' }}>
              <thead>
                <tr style={{ background: '#e5e5e5' }}>
                  <td style={{ width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>商品名称</td>
                  <td style={{ width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>医疗器械名称</td>
                  <td style={{ width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>规格型号</td>
                  <td style={{ width: '6.2%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>注册人/备案人</td>
                  <td style={{ width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>生产企业（含委托）</td>
                  <td style={{ width: '8.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>医疗器械生产许可证</td>
                  <td style={{ width: '6.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>数量</td>
                  <td style={{ width: '5.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>单位</td>
                  <td style={{ width: '6.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>单价</td>
                  <td style={{ width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>金额</td>
                  <td style={{ width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>医疗器械注册证</td>
                  <td style={{ width: '6.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>生产批号</td>
                  <td style={{ width: '6.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>失效日期</td>
                  <td style={{ width: '7.6%', border: '1px solid', textAlign: 'center', padding: '5px 0' }}>存储条件</td>
                </tr>
              </thead>
              <tbody style={{ fontSize: '12px' }}>
                {
                  data.product_print_list
                    ? data.product_print_list.map((item, index) => {
                      return <tr key={index}>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.product_name)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.device_name)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.specification_model)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.register_name)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.producer)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.producer_qual_code)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.qty)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.unit)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.unit_price)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.price)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.mdrc)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.batch_no)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.expiry_date_str)}</td>
                        <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>{renderText(item.storage)}</td>
                      </tr>
                    }) : ''
                }
              </tbody>
              <tfoot>
                <tr>
                  <td style={{ border: '1px solid', textAlign: 'center', padding: '5px 0' }}>汇总：</td>
                  <td colSpan={13} style={{ border: '1px solid', textAlign: 'right', padding: '5px 0' }}>
                    <span style={{ marginRight: '20px' }}>总共数量合计：{data.count_sum != null ? data.count_sum : 0}</span>
                    <span style={{ marginRight: '20px' }}>总共金额合计：{data.price_sum != null ? data.price_sum : 0}</span>
                    <span style={{ marginRight: '20px' }}>{data.price_sum_lower || ''}</span>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <p style={{ textAlign: 'center', margin: '20px 0' }}>
            <Button type="primary" shape="round" onClick={print}>打印</Button>
            <Button shape="round" style={{ marginLeft: '25px' }} onClick={goback}>返回</Button>
          </p>
        </div>
      </Spin>
    </div>
  )
}

export default WithPrintNew


// WEBPACK FOOTER //
// ./src/pages/deliverGoodsNew/withPrint.js